module.exports = __webpack_public_path__ + "static/media/usecase-card-1-icon.09214431.svg";